export const SST_ANOMALY_DATA_REQUEST_SEND = 'SST_ANOMALY_DATA_REQUEST_SEND';
export const SST_ANOMALY_DATA_REQUEST_STREAMING =
  'SST_ANOMALY_DATA_REQUEST_STREAMING';
export const SST_ANOMALY_DATA_REQUEST_PROCESSING =
  'SST_ANOMALY_DATA_REQUEST_PROCESSING';
export const SST_ANOMALY_DATA_REQUEST_SUCCESS =
  'SST_ANOMALY_DATA_REQUEST_SEND_SUCCESS';
export const SST_ANOMALY_DATA_REQUEST_FAILURE =
  'SST_ANOMALY_DATA_REQUEST_SEND_FAILURE';

export const ADT_ANOMALY_DATA_REQUEST_SEND = 'ADT_ANOMALY_DATA_REQUEST_SEND';
export const ADT_ANOMALY_DATA_REQUEST_STREAMING =
  'ADT_ANOMALY_DATA_REQUEST_STREAMING';
export const ADT_ANOMALY_DATA_REQUEST_PROCESSING =
  'ADT_ANOMALY_DATA_REQUEST_PROCESSING';
export const ADT_ANOMALY_DATA_REQUEST_SUCCESS =
  'ADT_ANOMALY_DATA_REQUEST_SEND_SUCCESS';
export const ADT_ANOMALY_DATA_REQUEST_FAILURE =
  'ADT_ANOMALY_DATA_REQUEST_SEND_FAILURE';

export const AVG_SST_ANOMALY_DATA_REQUEST_SEND =
  'AVG_SST_ANOMALY_DATA_REQUEST_SEND';
export const AVG_SST_ANOMALY_DATA_REQUEST_STREAMING =
  'AVG_SST_ANOMALY_DATA_REQUEST_STREAMING';
export const AVG_SST_ANOMALY_DATA_REQUEST_PROCESSING =
  'AVG_SST_ANOMALY_DATA_REQUEST_PROCESSING';
export const AVG_SST_ANOMALY_DATA_REQUEST_SUCCESS =
  'AVG_SST_ANOMALY_DATA_REQUEST_SEND_SUCCESS';
export const AVG_SST_ANOMALY_DATA_REQUEST_FAILURE =
  'AVG_SST_ANOMALY_DATA_REQUEST_SEND_FAILURE';

export const AVG_ADT_ANOMALY_DATA_REQUEST_SEND =
  'AVG_ADT_ANOMALY_DATA_REQUEST_SEND';
export const AVG_ADT_ANOMALY_DATA_REQUEST_STREAMING =
  'AVG_ADT_ANOMALY_DATA_REQUEST_STREAMING';
export const AVG_ADT_ANOMALY_DATA_REQUEST_PROCESSING =
  'AVG_ADT_ANOMALY_DATA_REQUEST_PROCESSING';
export const AVG_ADT_ANOMALY_DATA_REQUEST_SUCCESS =
  'AVG_ADT_ANOMALY_DATA_REQUEST_SEND_SUCCESS';
export const AVG_ADT_ANOMALY_DATA_REQUEST_FAILURE =
  'AVG_ADT_ANOMALY_DATA_REQUEST_SEND_FAILURE';
